export default "__VITE_ASSET__Dczb8XU___"